module.exports = __webpack_public_path__ + "static/img/2_1.a304530.png";


//////////////////
// WEBPACK FOOTER
// ./static/officeImg/index/2_1.png
// module id = gFEM
// module chunks = 1